import React, { useMemo, useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  ConfirmDangerModalComponent,
  NameField,
  SurnameField,
  IDNumberComponent,
  PassportComponent,
  IDType,
  OneColumn,
  MenuItemsForDropDown,
  TrustNumberField,
  CompanyRegNoField,
} from "@soqs/common";
 
import { Form, FormSpy } from "react-final-form";
import {
  updateFormState,
  submitFormAsync,
  formState,
  dropdownoptions,
  dropdownsloading,
  isPrepop,
  isLoading,
  getPrepopDataAsync,
  isSOQS,
} from "../../features/trnAppSlice";
import CompanyNameTrustName from "../Helpers/UserComponents/CompanyNameTrustNameField";
import SelectComponent from "../Helpers/UserComponents/SelectComponent";
import { config } from "../../config";

export default function WhatsMyTaxNumberForm() {
  const dispatch = useDispatch();
  const dropdownopts = useSelector(dropdownoptions);
  const dropdownoptsloading = useSelector(dropdownsloading);
  const reduxFormState = useSelector(formState);
  const prepop = useSelector(isPrepop);
  const loading = useSelector(isLoading);
  const kiosktoken = new URLSearchParams(window.location.search).get("token");
  const soqs = useSelector(isSOQS);

  //Hidding Company Name Trust Name Component
  const [ setHideCompanyTrust] = useState(true);

  // Clean Internal Form State
  const initialState = {
    IDType: IDType.RSA_Id,

    //testing
    // Name: "Tester",
    // Surname: "Surname",
    // mobile_taxpayer: "0823384475",
    // IDNumber: "3407295023083",
  };

  const prefilledState = useMemo(
    () => reduxFormState?.values ?? initialState,
    []
  );

  // Internal State
  const [confirmClearModal, setConfirmClearModal] = useState(false);
  const handleSubmit = async () => {
    await dispatch(submitFormAsync());
  };

  //Get Prepop if there is kiosk token
  useEffect(() => {
    if (kiosktoken && loading) {
      dispatch(getPrepopDataAsync());
    }
    return () => {};
  }, []);

  return (
    <>
      <Grid size={{ xs: 12}}>
        <Form onSubmit={handleSubmit} initialValues={prefilledState}>
          {({ handleSubmit, form,  values  }) => (
            <>
              <FormSpy
                onChange={(state) => {
                  dispatch(updateFormState(state));
                }}
              />
              <Card>
                <CardHeader title="Your Identification Details" />
                <CardContent>
                  <Grid container columnSpacing={1.5} rowSpacing={0.5}>
                    <OneColumn>
                      <SelectComponent
                        label="ID Type"
                        name="IDType"
                        required={true}
                        options={MenuItemsForDropDown(
                          "idtype",
                          dropdownopts,
                          false
                        )}
                        optionsloading={dropdownoptsloading}
                        disabled={prepop?.IDType}
                      />
                    </OneColumn>
                    <OneColumn>
                      {values?.IDType == IDType.RSA_Id ? (
                        <IDNumberComponent
                          disabled={prepop?.IDNumber}
                          name="IDNumber"
                        />
                      ) : values?.IDType == IDType.Passport ? (
                        <PassportComponent
                          disabled={prepop?.IDNumber}
                          name="IDNumber"
                        />
                      ) : values?.IDType == IDType.CompanyRegistrationNumber ? (
                        <CompanyRegNoField
                          disabled={prepop?.IDNumber}
                          name="IDNumber"
                        />
                      ) : values?.IDType == IDType.TrustNumber ? (
                        <TrustNumberField
                          disabled={prepop?.IDNumber}
                          name="IDNumber"
                        />
                      ) : (
                        <IDNumberComponent
                          aria-label="ID Number"
                          name="IDNumber"
                        />
                      )}
                    </OneColumn>
                    <OneColumn>
                      <NameField
                        aria-label="Name"
                        disabled={prepop?.Name}
                        name="Name"
                      />
                    </OneColumn>
                    <OneColumn>
                      <SurnameField
                        aria-label="Surname"
                        disabled={prepop?.Surname}
                        name="Surname"
                      />
                    </OneColumn>
                    <OneColumn>
                      {(values?.IDType == IDType.RSA_Id) |
                      (values?.IDType == IDType.Passport) ? (
                        setHideCompanyTrust
                      ) : (
                        <CompanyNameTrustName aria-label="Company Name or Trust Name" />
                      )}
                    </OneColumn>
                  </Grid>
                </CardContent>
              </Card>

              <Card>
                <CardContent>
                  <Grid container columnSpacing={1.5} rowSpacing={0.5}>
                    <Grid size={{ xs: 12}}>
                      <Grid container justifyContent="space-between">
                        <Grid>
                          {!soqs && (
                            <Button
                              aria-label="Reset Button"
                              type="button"
                              variant="outlined"
                              onClick={() => {
                                setConfirmClearModal(true);
                              }}
                            >
                              Reset
                            </Button>
                          )}
                        </Grid>
                        <Grid>
                          <Button
                            //align="right"
                            aria-label="Submit Button"
                            loading={loading}
                            type="submit"
                            variant="contained"
                            onClick={handleSubmit}
                          >
                            Submit
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              <ConfirmDangerModalComponent
                open={confirmClearModal}
                onClose={() => {
                  setConfirmClearModal(false);
                }}
                cbConfirm={() => {
                  form.restart(initialState);
                  setConfirmClearModal(false);
                }}
                title="Reset form"
                subheader="Are you sure you want to clear the form?"
                confirmText="Clear"
              />
              {["development"].includes(
                config.ENVIRONMENT
              ) ? (
                <pre>{JSON.stringify(values, null, 2)}</pre>
              ) : (
                <></>
              )}
            </>
          )}
        </Form>
      </Grid>
    </>
  );
}
